import React from "react";
import { Link } from "react-router-dom";
import { useDemo } from "@/context/DemoContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, ArrowRight } from "lucide-react";

const ATTIVITA = [
  { titolo: "Apri un nuovo ticket", desc: "Vai su Ticket → Nuovo ticket. Inserisci il numero ticket (testo libero), poi cliente, stabilimento e descrizione. Salva per creare il ticket." },
  { titolo: "Prova come tecnico", desc: "Cambia profilo in alto a destra scegliendo Tecnico Interno A. Vedrai solo i tuoi interventi e potrai compilare un rapporto con più giornate." },
  { titolo: "Genera un consuntivo", desc: "Apri un ticket con rapporti confermati (es. il caso in loco su Ondulati Veneti) e vai alla Fase 5 per creare bozza, controllare i totali e confermare." },
  { titolo: "Registra una fattura", desc: "Passa al profilo Gaia (Amministrazione) e nella Fase 7 di un ticket confermato registra numero, data e importo. La differenza aggiorna lo stato." },
  { titolo: "Chiudi e riapri un ticket", desc: "Solo Elisa o Amministratore demo. Prova la chiusura, indica una motivazione, poi riapri per verificare lo storico." },
];

export default function HomePage() {
  const { data, profile } = useDemo();
  const aperti = data.tickets.filter(t => t.stato !== "Chiuso").length;
  const chiusi = data.tickets.filter(t => t.stato === "Chiuso").length;

  return (
    <div className="p-4 md:p-8 max-w-5xl mx-auto">
      <div className="mb-8">
        <div className="text-sm text-slate-500 mb-2">Benvenuto, {profile.nome}</div>
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">
          Emmepi Service <span className="text-blue-700">Demo</span>
        </h1>
        <p className="text-slate-600 mt-2 max-w-2xl">
          Un ambiente dimostrativo per validare il processo di assistenza tecnica: apertura,
          triage, assegnazione, rapporti, consuntivo, conferma cliente, fatturazione e chiusura.
        </p>
        <div className="flex gap-3 mt-4 text-sm">
          <Badge variant="outline">{aperti} ticket attivi</Badge>
          <Badge variant="outline">{chiusi} chiusi</Badge>
          <Badge variant="outline">{data.clienti.length} clienti</Badge>
          <Badge variant="outline">{data.tecnici.length} tecnici</Badge>
        </div>
      </div>

      <Card className="mb-6">
        <CardHeader><CardTitle>Cinque attività da provare</CardTitle></CardHeader>
        <CardContent>
          <ol className="space-y-3">
            {ATTIVITA.map((a, i) => (
              <li key={i} className="flex gap-3">
                <div className="w-7 h-7 rounded-full bg-blue-100 text-blue-800 flex items-center justify-center font-bold flex-shrink-0">{i+1}</div>
                <div>
                  <div className="font-semibold text-slate-900">{a.titolo}</div>
                  <div className="text-sm text-slate-600">{a.desc}</div>
                </div>
              </li>
            ))}
          </ol>
          <Link to="/ticket" className="inline-flex items-center gap-2 mt-6 text-blue-700 font-semibold hover:underline" data-testid="home-go-tickets">
            Vai al cruscotto ticket <ArrowRight className="w-4 h-4" />
          </Link>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle className="flex items-center gap-2"><CheckCircle2 className="w-5 h-5 text-blue-700" /> Cosa è stato incluso in questa demo</CardTitle></CardHeader>
        <CardContent>
          <ul className="grid md:grid-cols-2 gap-2 text-sm text-slate-700">
            <li>· Selettore profili "Prova come" con 7 ruoli</li>
            <li>· 8 clienti, stabilimenti multipli, contatti e tecnici precaricati</li>
            <li>· 12 ticket distribuiti tra le fasi con casi variati</li>
            <li>· Otto fasi con stati Da fare, In lavorazione, Completata, N/A</li>
            <li>· Rapporti tecnici con più giornate, firma dimostrativa e blocco</li>
            <li>· Consuntivo con bozza, versioni e conferma</li>
            <li>· Fatturazione parziale con controllo di coerenza</li>
            <li>· Chiusura manuale con motivazione e storico riaperture</li>
            <li>· Feedback esportabili in CSV · Allegati JPG/PNG/PDF</li>
          </ul>
          <div className="mt-4 text-xs text-slate-500 border-t pt-3">
            Le funzioni simulate (email in ingresso, firma, SharePoint, offline, Gamma) sono chiaramente etichettate. Consulta la pagina "Ipotesi demo".
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
